import {
    ADDGATEWAYACCOUNT_SUCCESS,
    ADDGATEWAYACCOUNT_FAILED,
    RESET_ADDGATEWAYACCOUNT,
    LOADING_ADDGATEWAYACCOUNT,
    NETWORK_ERROR_ADDGATEWAYACCOUNT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddGatewayAccount = () => {
    return { type: RESET_ADDGATEWAYACCOUNT };
};

const addGatewayAccount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDGATEWAYACCOUNT });
    await partnerServices
        .post("addGatewayAccount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addGatewayAccountsuccess(res.data));
                    break;
                default:
                    dispatch(addGatewayAccountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDGATEWAYACCOUNT,
                payload: err
            });
        });
};
function addGatewayAccountsuccess(data) {
    return {
        type: ADDGATEWAYACCOUNT_SUCCESS,
        payload: data
    };
}
function addGatewayAccountFailed(data) {
    return {
        type: ADDGATEWAYACCOUNT_FAILED,
        payload: data
    };
}

export { resetAddGatewayAccount, addGatewayAccount };
